import { decodeValue } from 'helpers/hashId';
import { costComponent, productDetailFields, productHeaderFields, RenderInput } from 'pages/Componets/ItemMaster/model/FieldConfig';
import React, { useEffect, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom'
import { data } from '../../itemMaster/index';

const InwardFromVendorProcess = () => {
    const { id } = useParams()
    const navigate = useNavigate();
    const [showRejectConfirm, setShowRejectConfirm] = useState(false);

    const decodedId = decodeValue(id);
    console.log(decodedId)
    const {
        register,
        handleSubmit,
        reset,
        setFocus,
        control,
        watch,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm<any>();

    const selectedDetailProductType = watch("materialType");

    useEffect(() => {
        if (selectedDetailProductType === "Gold") {
            ["shape", "color", "size"].forEach((fieldName) => {
                setValue(fieldName, "");
            });
        }
    }, [selectedDetailProductType, setValue]);
    const onSubmitForm = (data: any) => {
        console.log(data)
        // reset();
    };

    useEffect(() => {
        if (data?.length) {
            const record = data.find((d: any) => d.id === decodedId);
            if (record) {
                reset(record);
            }
        }
    }, [decodedId, reset]);

    const handleReject = async () => {
        try {
            navigate(-1)
        } catch (error) {
            
        }
    }
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Bag Details</h5>
                        </Card.Header>
                        <Card.Body>
                            <form id="itemForm" className="w-100">
                                <div className="row g-2 p-2 border rounded mb-3">
                                    <div className="col-12 mb-1">
                                        <h5 className="mb-0">Product Details</h5>
                                    </div>

                                    {productHeaderFields.map((f) => (
                                        <RenderInput
                                            isDisabled={true}
                                            key={f.name}
                                            field={f}
                                            register={register}
                                            errors={errors}
                                            control={control}
                                        />
                                    ))}
                                </div>

                                <div className="row g-2 p-2 border rounded mb-3">


                                    {productDetailFields.map((f) => {
                                        if (
                                            selectedDetailProductType === "Gold" &&
                                            ["shape", "color", "size"].includes(f.name)
                                        ) {
                                            return null;
                                        }

                                        return (
                                            <RenderInput
                                                isDisabled={true}
                                                key={f.name}
                                                field={f}
                                                register={register}
                                                errors={errors}
                                                control={control}
                                            />
                                        );
                                    })}
                                </div>
                                <div className="row g-2 p-2 border rounded mb-3">
                                    <div className="col-12 mb-1">
                                        <h5 className="mb-0">Cost Details</h5>
                                    </div>
                                    {costComponent.map((f) => (
                                        <RenderInput
                                            key={f.name}
                                            field={f}
                                            register={register}
                                            errors={errors}
                                            control={control}
                                        />
                                    ))}
                                </div>
                            </form>

                            <div>
                                <div className='d-flex justify-content-end gap-2 align-items-center'>
                                    <button
                                        className='btn add-btn'
                                        onClick={() => setShowRejectConfirm(true)}
                                    >
                                        Reject
                                    </button>
                                    <button
                                        className='btn submit-btn'
                                        type='submit'
                                        onClick={handleSubmit(onSubmitForm)}
                                    >
                                        Approve
                                    </button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <Modal
                show={showRejectConfirm}
                onHide={() => setShowRejectConfirm(false)}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Reject</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-break">
                    <h6>
                        Are you sure you want to reject
                    </h6>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="btn add-btn"
                        onClick={() => setShowRejectConfirm(false)}
                    >
                        No
                    </Button>
                    <Button
                        variant="btn submit-btn"
                        onClick={() => handleReject()}
                    // disabled={loading}
                    >
                        {/* {loading ? 'Deleting...' : 'Delete'} */}
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default InwardFromVendorProcess
